<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-md-space-between align-center flex-wrap justify-center">
        <div class="d-flex align-center">
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Calendario prenotazioni {{title}}</h2>
          <h3 class="mx-3" v-else>Calendario prenotazioni {{title}}</h3>
        </div>
        <div class="d-flex align-center justify-end" >
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">{{clockDate}} {{clockTime}}</h2>
          <h3 class="mx-3" v-else>{{clockDate}} {{clockTime}}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>

      <v-col cols="12">
        <booking-calendar ref="bookings" :seats-type="seatsType" :calendar-hours="hours"></booking-calendar>
      </v-col>
      <v-col cols="12" v-if="isAdmin" >
        <seats-calendar :calendar-hours="hours" @refresh="refreshHours()" :seats-type="seatsType"></seats-calendar>
      </v-col>
    </v-row>


  </v-container>
</template>

<script lang="ts">
import utils from '../utils';
import {type BookingDisplay, type CalendarHour, SeatsType} from '@/models.ts'
import {DateTime} from "luxon";
import {computed, inject, onBeforeUnmount, onMounted, type PropType, ref, useTemplateRef, watch} from "vue";
import type {Globals} from "@/plugins/globals.ts";
import api from "@/api";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import BookingCalendar from "@/components/BookingCalendar.vue";
import SeatsCalendar from "@/components/SeatsCalendar.vue";
import {useRoute, useRouter} from "vue-router";

export default {
  components : {SeatsCalendar, BookingCalendar },
  props : {
    title : {
      type : String,
      required : true,
    },
    seatsType : {
      type : String as PropType<SeatsType>,
      required: true,
      default : SeatsType.exp,
    }
  },
  setup(props, ctx) {

    const auth = inject('auth') as Auth
    const globals = inject('globals') as Globals
    const messages = inject('messages') as Messages
    const router = useRouter()
    const route = useRoute()
    const bookings = useTemplateRef<typeof BookingCalendar>('bookings')

    let clock:any
    const clockDate = ref('')
    const clockTime = ref('')

    const loading = ref(false)

    const hours = ref<CalendarHour[]>([])

    const refreshHours = async () => {
      loading.value = true;
      const res = await api.list<CalendarHour>('hours', { type : props.seatsType }, 0, 0, '+time')
      loading.value = false
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }
      hours.value = res.data ?? []
    }

    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      await router.isReady()

      clock = setInterval(()=>{
        let now = DateTime.now();
        clockDate.value = now.toFormat('DDD')
        clockTime.value = now.toFormat('HH:mm:ss')
        //if(calendarReady.value) cal.value?.updateTimes()
      },1000)

      await Promise.all([
        refreshHours(),
      ])

      if(route.query.date) {
        const dt = DateTime.fromISO(route.query.date as string)
        if(dt && dt.isValid) {
          // +12 per evitare fusi orari strani
          bookings.value?.setDate(dt.plus({hour:12}))
        }
      }

      if(route.query.event) {
        setTimeout(()=>{
          bookings.value?.openEvent(route.query.event as string)
        }, 2000)

      }

    })
    onBeforeUnmount(async ()=>{
      clearInterval(clock)
    })


    return {
      isEditor : auth.isEditor,
      isAdmin : auth.isAdmin,
      clockDate,
      clockTime,
      loading,
      hours,
      formatDate : utils.formatDate,
      formatDateTime : utils.formatDateTime,
      refreshHours,

    }

  }

}
</script>
<style scoped>

.header-cal {
  position: absolute;
  left: 0;
  right: 0;
  pointer-events: none;
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}
.v-current-time .first::before {
  content: '';
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}

</style>